import React from 'react';

import { computed } from 'mobx';
import type { IComputedValueOptions } from 'mobx';

const useComputed = <T extends unknown>(
  factory: () => T,
  deps: React.DependencyList,
  options?: IComputedValueOptions<T>
): T => {
  return React.useMemo(() => computed(factory, options), deps).get();
};

export default useComputed;
